<!-- 绑定谷歌认证 -->
<template>
    <div class="google-bind">
        <a-scrollbar class="google-con">
            <div class="title">
                <a-button class="back-btn" @click="goBack">
                    <template #icon>
                        <icon-left/>
                    </template>
                </a-button>
                <span>{{ $t('personal.bind_google_auth') }}</span>
            </div>
            <div class="content-warp">
                <!-- 加载状态 -->
                <div v-if="isLoading" class="loading-container">
                    <a-spin size="large" />
                    <p>{{ $t('common.loading') }}</p>
                </div>
                
                <!-- 主要内容 -->
                <div v-else>
                <div class="label">
                    <div class="label-title">
                        <span>1</span>
                        <span>{{ $t('personal.download_google_auth') }}</span>
                    </div>
                    <div class="label-con">
                        <p>{{ $t('personal.web_google_play') }}</p>
                        <p>{{ $t('personal.ios_app_store') }}</p>
                        <p>{{ $t('personal.android_play_store') }}</p>
                        <a-button class="btn" @click="openGooglePlay">
                            <svg viewBox="0 0 1024 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="9516" width="20" height="20">
                                <path
                                    d="M118.016 45.696c19.52-17.28 47.488-17.344 69.632-4.928 191.232 103.168 381.056 208.64 571.328 313.472-53.056 52.48-107.52 103.744-160.448 156.288l-2.432 2.176C439.68 354.368 276.48 202.24 118.016 45.696z"
                                    fill="#01F076" p-id="9517"></path>
                                <path
                                    d="M96.32 160.64c0.256-38.272-5.312-82.048 21.184-114.24C277.76 202.88 442.304 354.816 600.64 512.96 438.528 668.16 279.232 825.6 117.504 981.248c-15.36-23.68-20.672-54.848-21.44-82.048 0.512-246.208 0.128-492.416 0.32-738.624z"
                                    fill="#01CCFF" p-id="9518"></path>
                                <path
                                    d="M760.192 352.448c64.832 35.2 128.896 71.488 193.152 107.52 22.592 12.16 43.712 36.096 37.568 62.976-6.656 27.072-33.408 41.344-56.128 54.016-58.496 30.528-114.752 64.96-173.056 96-54.208-54.016-110.464-106.112-163.008-161.6 53.312-53.44 108.16-105.536 161.472-158.912z"
                                    fill="#FFD700" p-id="9519"></path>
                                <path
                                    d="M595.584 514.816l2.432-2.112c51.84 54.4 107.392 105.536 160.896 158.528-186.432 104.32-373.696 207.36-560.96 310.4-23.936 14.08-57.6 17.536-79.936-1.28 158.912-155.52 318.272-310.464 477.568-465.536z"
                                    fill="#F53349" p-id="9520"></path>
                            </svg>
                            Google Play
                        </a-button>

                    </div>
                </div>
                <div class="label">
                    <div class="label-title">
                        <span>2</span>
                        <span>{{ $t('personal.add_key_to_google_auth') }}</span>
                    </div>
                    <div class="label-con">
                        <p>{{ $t('personal.scan_qr_or_manual') }}</p>
                        <div class="code-box">
                            <canvas></canvas>
                            <div class="code-text">
                                <p>{{ googleAuthKey }}</p>
                                <a-button class="copy" @click="copyKey">
                                    <icon-copy/>
                                    {{ $t('personal.copy_key') }}
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="label">
                    <div class="label-title">
                        <span>3</span>
                        <span>{{ $t('personal.enter_google_auth_code') }}</span>
                    </div>
                    <div class="label-con">
                        <p>{{ $t('personal.google_auth_code') }}</p>
                        <a-input class="input" :class="{'notVal': codeVal == ''}" v-model="codeVal" :placeholder="$t('personal.google_auth_code_placeholder')"></a-input>
                        <p class="tip" v-if="codeVal == ''">{{ $t('personal.google_auth_code_placeholder') }}</p>
                        <a-button class="confirm-button" @click="submitGoogleAuth" :loading="isSubmitting" :disabled="isSubmitting || !codeVal">{{ $t('personal.submit') }}</a-button>
                    </div>
                    </div>
                </div>
            </div>
        </a-scrollbar>
    </div>
</template>

<script>
import userApi from '@/common/api/user.js';

export default {
    name: 'bindGoogle',
    components: {},
    data() {
        return {
            codeVal: '',
            googleAuthKey: '', // 谷歌验证器密钥
            isSubmitting: false, // 提交状态
            isLoading: true // 加载状态
        };
    },
    mounted() {
        this.getGoogleAuthKey();
    },
    methods: {
        goBack() {
            this.$emit("safet-event");
        },
        async getGoogleAuthKey() {
            try {
                console.log('获取谷歌验证器密钥...');
                const response = await userApi.getGoogleCode();
                
                if (response && response.code === 200 && response.data) {
                    this.googleAuthKey = response.data.secret || response.data;
                    console.log('✅ 谷歌验证器密钥获取成功:', this.googleAuthKey);
                } else {
                    console.log('ℹ️ 使用默认密钥');
                    this.googleAuthKey = 'EB4WGCBTHCLVXZYQ'; // 默认密钥
                }
            } catch (error) {
                console.error('❌ 获取谷歌验证器密钥失败:', error);
                this.googleAuthKey = 'EB4WGCBTHCLVXZYQ'; // 默认密钥
            } finally {
                this.isLoading = false;
            }
        },
        copyKey() {
            // 使用现代浏览器的 Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(this.googleAuthKey).then(() => {
                    this.$message.success(this.$t('personal.key_copied_success'));
                }).catch(err => {
                    console.error('复制失败:', err);
                    this.fallbackCopy();
                });
            } else {
                // 降级方案：使用传统的 document.execCommand
                this.fallbackCopy();
            }
        },
        fallbackCopy() {
            // 创建临时文本区域
            const textArea = document.createElement('textarea');
            textArea.value = this.googleAuthKey;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            
            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    this.$message.success(this.$t('personal.key_copied_success'));
                } else {
                    this.$message.error(this.$t('personal.copy_failed'));
                }
            } catch (err) {
                console.error('复制失败:', err);
                this.$message.error(this.$t('personal.copy_failed'));
            }
            
            document.body.removeChild(textArea);
        },
        openGooglePlay() {
            // Google Play Store 链接
            const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
            
            // 在新窗口中打开链接
            window.open(googlePlayUrl, '_blank');
            
            console.log('打开Google Play Store:', googlePlayUrl);
        },
        async submitGoogleAuth() {
            if (this.isSubmitting) {
                return; // 防止重复提交
            }
            
            // 验证验证码格式
            if (!this.codeVal || this.codeVal.length !== 6) {
                this.$message.error(this.$t('register.code_format_incorrect'));
                return;
            }
            
            // 验证是否为纯数字
            if (!/^\d{6}$/.test(this.codeVal)) {
                this.$message.error(this.$t('personal.six_digit_verification_code_invalid'));
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                // 准备提交的数据
                const submitData = {
                    code: this.codeVal, // 6位验证码
                    secret: this.googleAuthKey // 谷歌验证器密钥
                };
                
                console.log('提交谷歌验证器绑定数据:', submitData);
                
                // 调用实际的API
                const response = await userApi.setGoogleSecret(submitData);
                
                if (response && response.code === 200) {
                    this.$message.success(this.$t('personal.google_authenticator_bound'));
                    // 绑定成功后返回上一页
                    setTimeout(() => {
                        this.goBack();
                    }, 1500);
                } else {
                    this.$message.error(response?.message || '绑定失败，请重试');
                }
            } catch (error) {
                console.error('绑定谷歌验证器失败:', error);
                this.$message.error(this.$t('personal.binding_code_invalid'));
            } finally {
                this.isSubmitting = false;
            }
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./bindGoogle.scss";
</style>
  
